document.addEventListener("DOMContentLoaded", function () {
    let cta = document.querySelector(".sc-campaign-banner__cta");
    let section = document.querySelector(".sc-campaign-banner").parentNode;
    cta.addEventListener("click", () => {
        section.nextElementSibling.scrollIntoView({ behavior: "smooth" });
    });
});